<template>
  <div>
    <el-dialog
      title=""
      :visible.sync="isOpen"
      width="680px"
      top="10vh"
      :close-on-click-modal="false"
      :append-to-body="isAppend"
      custom-class="word-info"
      :before-close="handleCloseBefore">
      <div class="title">未创建账户、未审核通过及培训历程有缺失教练员报名操作说明</div>
      <div class="content-info">
        <vue-scroll :ops="vuescrollOpt">
          <div class="wrapper">
              <p class="info">报名学员可登录中国足协官方网站www.thecfa.cn，在首页找到“教练员”板块，进入“教练员培训管理系统”中进行教练员资质和个人信息填写并报名本年度<span class="err">{{level | signLevelFilters}}级</span>课程。</p>
              <p class="info">1.已经在“教练员培训管理系统中”创建过帐户的教练可直接用自己的帐号登录，登录后点击“培训经历和证书”按钮，查看自己已确认的培训经历，将出现三种情况：</p>
              <p class="info">一是教练员资质信息完整，系统中最高级别为<span class="err">{{lowerLevel}}级</span>且教练员执照在有效期内。此时退回首页，选择“高端培训报名”，点击“B级及以上等级培训和补考报名”按钮，根据引导完成选择培训班及上传必要材料等报名步骤即可；</p>
              <p class="info">二是在已确认的培训经历中未看到自己在有效期内的<span class="err">{{lowerLevel}}级</span>培训记录。此时需要在页面下方找到绿色的“上传缺失资质入口”，进入后点击右上角“上传缺失资质”，提交本人<span class="err">{{lowerLevel}}级</span>及以下级别所有缺失的等级培训和继续教育培训信息，并点击页面右上角“此申请是否用于此次<span class="err">{{level | signLevelFilters}}级</span>报名”选择“是”提交，进入快速审核流程。审核通过后，将以短信形式通知个人，收到短信的教练员再登录系统，按照第一种情况完成报名步骤即可。</p>
              <p class="info">三是在已确认的培训经历中未看到自己在有效期内的<span class="err">{{lowerLevel}}级</span>培训记录，但在此前已提交过缺失资质审核申请，目前处于待审核状态。此时需要在页面下方找到绿色的“上传缺失资质入口”，进入后点击查看详情，在详情页右上角找到“此申请是否用于此次<span class="err">{{level | signLevelFilters}}级</span>报名”按钮，选择“是”提交，进入快速审核流程。审核通过后，将以短信形式通知个人，收到短信的教练员再登录系统，按照第一种情况完成报名步骤即可。</p>
              <p class="info">2.之前没有帐户，需要先在“教练员培训管理系统”首页点击“创建帐户”的教练员，也分为两种情况：</p>
              <p class="info">一是已经在“教练员培训管理系统”中提交过自己<span class="err">{{lowerLevel}}级</span>及继续培训经历，正在等待审核的教练员。需要点击系统首页下方“创建帐户”按钮输入自己之前创建帐户时的用户信息，进入待审核资质页面，点击右上方“此申请是否用于此次<span class="err">{{level | signLevelFilters}}级</span>报名”按钮，选择“是”并提交。审核通过后将以短信形式通知个人，收到短信的教练员再根据短信提示登录系统，完善个人信息，选择“高端培训报名”，点击“B级及以上等级培训和补考报名”按钮，根据引导上传必要材料完成报名步骤即可；</p>
              <p class="info">另一种是之前没有登录过“教练员培训管理系统”的教练员，点击系统首页下方“创建帐户”入口，根据引导完成个人系统帐号创建后，将自己参加过的<span class="err">{{lowerLevel}}级</span>及以下级别培训信息及继续教育信息补充完整后点击右上方“此申请是否用于此次<span class="err">{{level | signLevelFilters}}级</span>报名”按钮，选择“是”并提交。审核通过后将以短信形式通知个人，收到短信的教练员再根据短信提示登录系统，完善个人信息，选择“高端培训报名”，点击“B级及以上等级培训和补考报名”按钮，根据引导上传必要材料完成报名步骤即可。</p>
          </div>
        </vue-scroll>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { signLevelFilters } from "@/assets/js/yioksFilters";
  import createScrollOpt from "@/assets/js/vuescrollOption";
  export default {
    props: {
      level: {
        type: String,
        default: 'A'
      },
      isOpen: {
        type: Boolean,
        default: false
      },
      isAppend: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        vuescrollOpt: createScrollOpt(true),
      }
    },

    filters: {
      signLevelFilters,
    },

    computed: {
      lowerLevel() {
        const dic = { 'A': 'B', 'B': 'C', 'C': 'D', 'PRO': 'A'};
        if(this.level) {
          return dic[this.level]
        } else {
          console.error('level is needed')
          return '--'
        }
      }
    },

    methods: {
      handleCloseBefore() {
        this.$emit('update:isOpen', false);
      }
    }
  }
</script>

<style lang="stylus" scoped>
.content-info
  padding 0px 0px 20px
  height: 560px
  
  .info
    text-indent: 2em
    text-align: justify
    line-height: 2em
    font-size: 16px
    &:not(:last-child)
      margin-bottom: 10px
  // .list-content
  //   padding 0 1em
.err
  color: #f88594
.wrapper
  margin 0 25px 0
.title
  width:  100%
  font-size: 20px
  display: flex
  align-items: center
  justify-content: center
  font-weight: 600
  margin-bottom: 20px
</style>

<style lang="stylus">

.word-info
  .el-dialog__body
    padding 30px 5px 30px 0px
</style>
